<app-modal #consModal [modalConfig]="modalConfig">
  <div *ngIf="consultant">
    <div class="modal-body">
      <div class="cons-profile">
        <img
          class="cons-img"
          [src]="consultant.profileImage.url || imagePlaceholder"
          [altText]="consultant.profileImage.altText"
        />
        <div class="consultant-info">
          <h5>{{ consultant.fullName }}</h5>
          <div class="text-purple" i18n>Only Accepts Orders Directly</div>
          <button class="btn btn-call" i18n>
            <i class="fas fa-phone"></i>
            <img class="icon" src="assets/images/icons/phone.svg" /> CALL
          </button>
        </div>
      </div>
      <div class="send-message-title" i18n>Send a message</div>
      <form [formGroup]="contactWholesaleFormGroup">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="required" i18n>First Name</label>
              <input
                type="text"
                class="form-control"
                [formControlName]="FirstName"
                [disabled]="true"
                readonly="true"
                [identifier]="FirstName"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="required" i18n>Last Name</label>
              <input
                type="text"
                class="form-control"
                [formControlName]="LastName"
                [disabled]="true"
                readonly="true"
                [identifier]="LastName"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="required" i18n>Email address</label>
              <input
                type="text"
                class="form-control"
                [formControlName]="EmailAddress"
                [identifier]="EmailAddress"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="required" i18n>Mobile Phone</label>
              <input
                type="text"
                class="form-control"
                [formControlName]="MobilePhone"
                [identifier]="MobilePhone"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="required" i18n>Contact Timings</label>
              <app-ph-select
                identifier="contactTime"
                i18n-label
                [formControlName]="ContactTime"
                [options]="contactTimings"
              ></app-ph-select>
            </div>
          </div>
        </div>
        <div class="cart-title" i18n>Products I'm Interested in Purchasing</div>
        <div class="cart-table">
          <table class="table-sm">
            <thead>
              <tr>
                <th *ngFor="let column of orderLineColumns">
                  <span>{{ column.title }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let orderLine of orderLines">
                <td>
                  <div>
                    <div class="col py-2 pl-0 align-self-center">
                      <div>{{ orderLine.sku }} </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <p>{{ orderLine.quantity }}</p>
                  </div>
                </td>
                <td>
                  <div>{{ orderLine.productName }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group">
          <label class="required" i18n>Comments or Message</label>
          <textarea class="form-control" rows="2" required [formControlName]="message"></textarea>
        </div>
        <div *ngIf="!validContactMessage()" class="validation-error-message">
          <span i18n>Please enter message</span>
        </div>
        <div class="form-group">
          <re-captcha
            [siteKey]="sitekey"
            (resolved)="resolved($event)"
            (expired)="onExpired()"
            size="normal"
            theme="light"
          >
          </re-captcha>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <button type="button" class="btn" (click)="closedNoMessage()">
                  <img class="icon" src="assets/images/icons/Arrow14.svg" alt="Success" />
                </button>
              </div>
              <div>
                <button
                  class="btn btn-primary text-uppercase submit-button"
                  (click)="SendMessage()"
                  i18n
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</app-modal>
<app-consultant-contact-success-modal (SucceededDone)="SucceededDone()" #consContactSuccess>
</app-consultant-contact-success-modal>
